// extracted by mini-css-extract-plugin
export default {"box":"index_box__-AnN2","options":"index_options__uvi7L","list":"index_list__14-fm","antdPagination":"index_antdPagination__HDIm6"};